import PropTypes from "prop-types";

import { Box, Typography } from "../../../Components";
import { IMAGES } from "../../../Assets";

export default function MessageTemplate({ ...props }) {
  return (
    <div className="d-flex justify-content-end my-4">
      <Box
        background="#ADDD59"
        borderRadius="0.75rem 0.75rem 0 0.75rem"
        width="fit-content"
        maxWidth="50rem"
        className="px-3"
      >
        <Typography as="p" className="m-2">
          {props.message}
        </Typography>
      </Box>

      <img
        // src={IMAGES.USER_AVATAR}
        src={`https://ui-avatars.com/api/?name=${`${"Abid"} ${"Ali"}`}&background=fff&color=53972C`}
        alt=""
        width="60px"
        className="ms-2 rounded-5"
      />
    </div>
  );
}

MessageTemplate.propTypes = {
  message: PropTypes.string.isRequired,
};
